import React from "react"
import { Doughnut } from "react-chartjs-2";
import { useTranslation } from 'react-i18next';
import { isMobile } from "react-device-detect"

export const ScoreWheel = ({ score, totalMarks, correct, wrong, unattempted }) => {

    const { t } = useTranslation();

    const wheelHeight = (isMobile) ? "180" : "225"
    const topScoreMargin = (isMobile) ? "28%" : "34%"
    const topAttemptMargin = (isMobile) ? "37%" : "41%"


    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "20px"

            }}
        >
            <div
                style={{
                    marginRight: "-15.8%",
                    marginLeft: "-1.38%",
                    position: "relative",
                }}
            >
                <Doughnut
                    width="1600"
                    height={wheelHeight}
                    data={{
                        datasets: [
                            {
                                data: [
                                    score,
                                    totalMarks - score,
                                ],
                                backgroundColor: [
                                    "rgba(52, 73, 94, 0.75)",
                                    "rgba(52, 73, 94, 0.25)",
                                ],
                                borderColor: "transparent",
                            },
                        ],
                    }}
                    options={{
                        responsive: false,
                        maintainAspectRatio: true,
                        cutoutPercentage: 85,
                        tooltips: { enabled: false },
                        hover: { mode: null },
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: "48.5%",
                        // top: "34%"
                        top: topScoreMargin
                    }}
                >
                    <p>{t("Score")}</p>
                    <p>
                        {score} / {totalMarks}{" "}
                    </p>
                </div>
            </div>
            <div style={{ position: "relative", marginLeft: "-26.5%" }}>
                <Doughnut
                    width="1600"
                    height={wheelHeight}
                    // style={{ margin: "0" }}
                    data={{
                        datasets: [
                            {
                                data: [
                                    correct,
                                    wrong,
                                    unattempted,
                                ],
                                backgroundColor: [
                                    "#8EC563",
                                    "#C8716A",
                                    "rgba(52, 73, 94, 0.25)",
                                ],
                                borderColor: "transparent",
                            },
                        ],
                    }}
                    options={{
                        responsive: false,
                        maintainAspectRatio: true,
                        cutoutPercentage: 85,
                        tooltips: { enabled: false },
                        hover: { mode: null },
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: "46.8%",
                        // top: "41%",
                        top: topAttemptMargin,
                        width: "auto",
                    }}
                >
                    <p style={{ margin: "0" }}>
                        {" "}
                        <span style={{ color: "#8EC563" }}>
                            {correct}
                        </span>{" "}
                        {t("Correct")}{" "}
                    </p>
                    <p style={{ margin: "0" }}>
                        {" "}
                        <span style={{ color: "#C8716A" }}>
                            {wrong}
                        </span>{" "}
                        {t("Wrong")}{" "}
                    </p>
                    <p style={{ margin: "0" }}>
                        {" "}
                        <span style={{ color: "#34495E" }}>
                            {unattempted}
                        </span>{" "}
                        {t("Unattempted")}{" "}
                    </p>
                </div>
            </div>
        </div>

    )

}